import { render, staticRenderFns } from "./FileUploads.vue?vue&type=template&id=42591d6a&scoped=true&"
import script from "./FileUploads.vue?vue&type=script&lang=js&"
export * from "./FileUploads.vue?vue&type=script&lang=js&"
import style0 from "./FileUploads.vue?vue&type=style&index=0&id=42591d6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42591d6a",
  null
  
)

export default component.exports
import {QPage,QBreadcrumbs,QBreadcrumbsEl,QBanner,QBtn,QDialog,QCard,QCardSection,QCardActions,QBtnDropdown,QToggle,QSpinnerPuff,QTabs,QTab,QTabPanels,QTabPanel,QSeparator,QDate,QCheckbox,QTime,QSelect,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QBreadcrumbs,QBreadcrumbsEl,QBanner,QBtn,QDialog,QCard,QCardSection,QCardActions,QBtnDropdown,QToggle,QSpinnerPuff,QTabs,QTab,QTabPanels,QTabPanel,QSeparator,QDate,QCheckbox,QTime,QSelect})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
